import Route from '@ember/routing/route';
import { set } from '@ember/object';

export default Route.extend({
  afterModel(model) {
    set(model, 'currentStep', '1');
  },
});
